import React from "react";
import { useTheme } from "../../../../../hooks";
import { AlertConstants } from "../../../../../types";
import Alert from "../../../../alert/Alert";
import { StatusHolder } from "./MobileNavStatusStyles";
const MobileNavStatus = ({ status, displayEnvIndicator }) => {
    const { Theme } = useTheme();
    return (React.createElement(React.Fragment, null, !!status && (React.createElement(StatusHolder, { displayEnvIndicator: displayEnvIndicator },
        React.createElement(Alert, { id: "navigation-status", type: status.type || AlertConstants.TYPES.DANGER, styles: { ...Theme.alert, padding: "0", margin: "0", fontSize: ".75rem", borderRadius: 0 } },
            React.createElement("div", { className: "text-center w-100" }, status.text))))));
};
export default MobileNavStatus;
//# sourceMappingURL=MobileNavStatus.js.map